import axios from 'axios'
import MockAdapter from "axios-mock-adapter"

if (parseInt(process.env.VUE_APP_MOCK_API)) {
    var mock = new MockAdapter(axios)
    mock.onGet("/catalogues/205").reply(200, [{ id: "1", fr: "Mr", en: "Mr.", code: "M" }, { id: "2", fr: "Mme", en: "Miss", code: "F" }])
    mock.onGet("/catalogues/307").reply(200, [{ id: "q", fr: "Québec", en: "Quebec", code: "QC" }, { id: "o", fr: "Ontario", en: "Ontario", code: "ON" }])
    mock.onGet("/catalogues/303").reply(200, [{ id: "c", fr: "Canada", en: "Canada", code: "CA" }, { id: "usa", fr: "États-Unis", en: "United-States", code: "US" }])
    mock.onGet("/catalogues/208").reply(200, [{ id: "1", fr: "Dentiste", en: "Dentist", code: "DE" }, { id: "2", fr: "Infirmier", en: "Nurse", code: "IN" }])
    mock.onGet("/catalogues/5900").reply(200, [{
        id: "regulier",
        fr: "Membre régulier - 20$",
        en: "Regular member - $20",
        code: "ADH-REGULIER",
        montant: 20
    },
    {
        id: "horsCanada",
        fr: "Membre hors Canada - 40$",
        en: "Member outside Canada - $40",
        code: "ADH-REGULIER-HC",
        montant: 40

    },
    {
        id: "professionnelSante",
        fr: "Membre Conseil Professionnel de Diabète Québec - 35$",
        en: "Member of the Diabetes Québec Professional Council - $35",
        code: "ADH-PROFESSIONNEL",
        montant: 35
    }])
    mock.onGet("/catalogues/6525").reply(200, [{
        id: "papier",
        fr: "Papier",
        en: "Paper",
        code: "papier"
    },
    {
        id: "electronic",
        fr: "Électronique",
        en: "Electronic",
        code: "electronic"
    }])
    mock.onGet(/articles\/\d/).reply(200, {
        id: "produitId",
        titre: "Guide de poche",
        categorie: {
            fr: "Brochure gratuite",
            en: "Free brochure",
            id: 1
        },
        prix: 2,
        photo: "https://purepng.com/public/uploads/medium/purepng.com-bookbookillustratedwrittenprintedliterature-1421526452123em65d.png",

        description: {
            fr: "FR Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum alias beatae at eos, iure recusandae reprehenderit blanditiis debitis assumenda aspernatur veniam odio eveniet dignissimos temporibus sit ex quisquam distinctio aliquam!",
            en: "EN Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum alias beatae at eos, iure recusandae reprehenderit blanditiis debitis assumenda aspernatur veniam odio eveniet dignissimos temporibus sit ex quisquam distinctio aliquam!"
        }
    })
    mock.onGet(/articles/).reply(200, [
        {
            id: "1",
            titre: "Guide de poche",
            categorie: {
                fr: "Brochure gratuite",
                en: "Free brochure",
                id: 1
            },
            prix: 2,
            photo: "https://purepng.com/public/uploads/medium/purepng.com-bookbookillustratedwrittenprintedliterature-1421526452123em65d.png",
        },
        {
            id: "2",
            titre: "Guide de poche 2",
            categorie: {
                fr: "Brochure gratuite",
                en: "Free brochure",
                id: 1
            },
            prix: 2,
            photo: "https://purepng.com/public/uploads/medium/purepng.com-bookbookillustratedwrittenprintedliterature-1421526452123em65d.png",
        },
        {
            id: "3",
            titre: "Guide de poche 3",
            categorie: {
                fr: "Guide",
                en: "Guide",
                id: 2
            },
            prix: 10,
            photo: "https://purepng.com/public/uploads/medium/purepng.com-bookbookillustratedwrittenprintedliterature-1421526452123em65d.png",
        },
        {
            id: "4",
            titre: "Guide de poche 4",
            categorie: {
                fr: "Guide",
                en: "Guide",
                id: 2
            },
            prix: 10,
            photo: "https://purepng.com/public/uploads/medium/purepng.com-bookbookillustratedwrittenprintedliterature-1421526452123em65d.png",
        },
        {
            id: "5",
            titre: "Acceptez son diabète",
            categorie: {
                fr: "Livre",
                en: "Book",
                id: 3
            },
            prix: 15,
            photo: "https://purepng.com/public/uploads/medium/purepng.com-bookbookillustratedwrittenprintedliterature-1421526452123em65d.png",
        },
        {
            id: 6,
            titre: "Carnet autosurveillance glycémie",
            categorie: {
                fr: "Livre",
                en: "Book",
                id: 3
            },
            prix: 5,
            photo: "https://www.pinclipart.com/picdir/big/175-1754911_chapter-books-png-clipart.png",
        },
        {
            id: "7",
            titre: "Diabète et sexualité féminine",
            categorie: {
                fr: "Guide",
                en: "Guide",
                id: 2
            },
            prix: 25,
            photo: "https://www.pinclipart.com/picdir/big/175-1754911_chapter-books-png-clipart.png",
        },
        {
            id: "8",
            titre: "Mon diabète",
            categorie: {
                fr: "Brochure gratuite",
                en: "Free brochure",
                id: 1
            },
            prix: 2,
            photo: "https://openclipart.org/image/2400px/svg_to_png/67633/1276877947.png",
        },
        {
            id: "9",
            titre: "Le diabète au Québec",
            categorie: {
                fr: "Livre",
                en: "Book",
                id: 3
            },
            prix: 25,
            photo: "https://openclipart.org/image/2400px/svg_to_png/67633/1276877947.png",
        },
    ])
    mock.onPost("auth/login").reply(200, {
        nom: "Doe",
        prenom: "John",
        civilite: {
            id: "1",
            fr: "Monsieur",
            en: "Mister",
            code: "MR"
        },
        courriel: "john.doe@eudonet.com",
        anneeNaissance: 1994,
        adresse: {
            adresse: "123 Papineau",
            ville: "Montréal",
            province: {
                id: "q",
                fr: "Québec",
                en: "Québec",
                code: "QC"
            },
            codePostal: "F4R 5T1",
            telephone: "514-123-4567"
        }
    })
    mock.onPost("boutiques/calcul").reply(200, {
        fraisPoste: 7.5,
        fraisSup: 0,
        tps: 5,
        tvq: 10,
        total: 22.5
    })
}
export const Api = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL,
    withCredentials: false,
    headers: {
        Accept: 'application/json',
    }
})